import { PJAxios, usePJStore } from '@jaf/jaf-react-core';
import React, { useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Chips } from 'primereact/chips';

function Tag(props) {

    const [tags, setTags] = useState(props.tags);
    
    const getText = usePJStore((state) => state.i18n_getText)
    const { storage } = usePJStore((state) => state.storage)

    


    useEffect(() => {
        var url ='/gestioneConfigurazioni/getTags/'+ props.selectedNode.idItem;
        PJAxios().get(url).then((res) => {
            setTags(res.data);
        });
        
    }, [props.selectedNode]);

    const updateTags = () => {

        PJAxios().post('/gestioneConfigurazioni/updateTags', {tags: tags,selectedNodeId: props.selectedNode.idItem}).then((res) => {
            props.onTagUpdate(res.data);
        });
    }

    return (
        <>
            <Card className='surface-card' title={getText("GESTIONE_TAGS_TITLE")} subTitle={getText("GESTIONE_TAGS_SUBTITLE")}>
                <div className="p-fluid grid formgrid col-12">                    
                    <div className="field col-12 md:col-12">
                        <Chips onChange={(e) => setTags(e.value)} value={tags} />
                    </div>
                    <div className="field col-12 md:col-12">
                        <Button onClick={updateTags} icon="pi pi-save" label={getText("SALVA")}></Button>
                    </div>
                    
                </div>
            </Card>
        </>
    )
}

export default Tag
